import OrderExecutorCreateInvoiceStrategy from '@/domain/OrderExecutorCreateInvoiceStrategy'

export const AfterConfirmByCustomer = new OrderExecutorCreateInvoiceStrategy(0, 'После подтверждения приёма поставки')
export const OnShipmentWaybillCreation = new OrderExecutorCreateInvoiceStrategy(1, 'Одновременно с надкладной')